import { render, staticRenderFns } from "./ComposerAttachments.vue?vue&type=template&id=fa8aa728&scoped=true"
import script from "./ComposerAttachments.vue?vue&type=script&lang=js"
export * from "./ComposerAttachments.vue?vue&type=script&lang=js"
import style0 from "./ComposerAttachments.vue?vue&type=style&index=0&id=fa8aa728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8aa728",
  null
  
)

export default component.exports